import Vue from 'vue'
import Vuex from 'vuex'

import AuthModule from './store/auth.module'
import UserModule from './store/user.module'
import GeneralModule from './store/general.module'
import ClassModule from './store/class.module'
import DashboardModule from './store/dashboard.module'
import SubjectModule from './store/subject.module'
import ModulModule from './store/modul.module'
import SilabusModule from './store/silabus.module'
import MateriModule from './store/materi.module'
import DiscussModule from './store/discuss.module'
import TaskModule from './store/task.module'
import AppraisalModule from './store/appraisal.module'
import QuestionModule from './store/question.module'
import LearningActivity from './store/learning-activity.module'
import BackgroundModule from './store/background.module'
import LockSemesterModule from './store/lock-semester.module'
import Kelulusan from './store/kelulusan.module'
import TahunAjaranModule from './store/tahun-ajaran.module'
import PermissionRaporModule from './store/permission-rapor.module'
import FormulirPendaftaranModule from './store/formulir-pendaftaran.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
      auth: AuthModule,
      user: UserModule,
      general: GeneralModule,
      class: ClassModule,
      dashboard: DashboardModule,
      subject: SubjectModule,
      modul: ModulModule,
      silabus: SilabusModule,
      materi: MateriModule,
      discuss: DiscussModule,
      task: TaskModule,
      appraisal: AppraisalModule,
      learningActivity: LearningActivity,
      background: BackgroundModule,
      LockSemester: LockSemesterModule,
      question: QuestionModule,
      Kelulusan:Kelulusan,
      TahunAjaranModule:TahunAjaranModule,
      PermissionRapor: PermissionRaporModule,
      FormulirPendaftaran: FormulirPendaftaranModule,
  }
})
